import { Locale } from './locale';

const supportedLocales: Locale[] = [
  new Locale('en', 'EN'),
  new Locale('es', 'ES'),
  new Locale('pl', 'PL'),
  new Locale('ru', 'RU'),
  new Locale('sv', 'SV'),
  new Locale('uk', 'UA') // UK would be more correct
];

export default supportedLocales;
